import DOMPurify from "dompurify";
import { marked } from "marked";
import { useMemo } from "react";
import { cn } from "@/lib/utils";

export const ALLOWED_TAGS = ["p", "br", "strong", "em", "ul", "ol", "li", "a", "h3", "h4", "code", "blockquote"];
export const ALLOWED_ATTR = ["href"];

let hookInstalled = false;
function installHook(): void {
  if (hookInstalled) return;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener");
    }
  });
  hookInstalled = true;
}

/** Markdown to sanitised HTML. Raw HTML in the source never survives except the allow-listed tags. */
export function renderMarkdown(source: string): string {
  installHook();
  const html = marked.parse(source, { async: false, gfm: true, breaks: false });
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}

export function Markdown({ source, className }: { source: string | null | undefined; className?: string }) {
  const html = useMemo(() => renderMarkdown(source ?? ""), [source]);
  if (!source) return null;
  return <div className={cn("prose-cm", className)} dangerouslySetInnerHTML={{ __html: html }} />;
}
